export default __webpack_public_path__ + "static/media/c_5.69d5ef6f.svg";